import { site } from "../data/site";

const absoluteUrl = (path = "/") =>
  path.startsWith("http") ? path : `${site.domain}${path.startsWith("/") ? path : `/${path}`}`;

export function localBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: site.brand,
    url: site.domain,
    email: site.email,
    telephone: site.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: site.address.slice(0, 2).join(", "),
      addressLocality: "Singapore",
      postalCode: "417808",
      addressCountry: "SG",
    },
    openingHours: site.businessHours,
    image: absoluteUrl(site.heroImages[0]),
    description: site.heroLead,
    areaServed: {
      "@type": "Country",
      name: "Singapore",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Stone polishing and restoration services",
      itemListElement: site.serviceGroups.map((group) => ({
        "@type": "OfferCatalog",
        name: group.name,
        itemListElement: group.services.map((service) => ({
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: service.title,
          },
        })),
      })),
    },
  };
}

export function serviceSchema(title: string, description: string, path: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: title,
    description,
    provider: {
      "@type": "LocalBusiness",
      name: site.brand,
      email: site.email,
      telephone: site.phone,
      url: site.domain,
    },
    areaServed: {
      "@type": "Country",
      name: "Singapore",
    },
    url: absoluteUrl(path),
  };
}

export function faqSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: site.faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
}
